// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination_plgexternal_pagination__NWLJw","box":"pagination_plgexternal_box__U7QbZ","arrowLeft":"pagination_plgexternal_arrowLeft__15dVE"};